import { render, staticRenderFns } from "./saveChanges.vue?vue&type=template&id=d1b68328&scoped=true"
import script from "./saveChanges.vue?vue&type=script&lang=ts"
export * from "./saveChanges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b68328",
  null
  
)

export default component.exports